import React, {useEffect, useState} from 'react';
import {Form, Input, Button} from 'reactstrap';
import CommSelect from './CpmCommSelect';
import {formatSelect} from '../../script/commFunc';
import CommPFindCli from './CpmCommPFindCli';
import useDidMountEffect from 'script/useDidMountEffect';
import { useExtSubmission } from 'api';

/**
 *
 * User : 이연우
 * Date : 2023.05.09
 * @ file : Components/Common/CpmCommCli.js
 * @ Desc : 광고주 공통 Component
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {HTMLInputElement} focusCliRef - ref
 * @param {boolean} isDisabled - disabled 여부
 * @param {boolean} essential - 필수 여부
 */
const CpmCommCli = ({
    params, 
    setParams, 
    focusCliRef, 
    isDisabled,
    essential = false,
    cable = ""
}) => {
    const extSubmission = useExtSubmission();
    const disabled = sessionStorage.getItem("cliNm") ? true : isDisabled;
    const [options, setOptions] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const setParam = (props) => {
        setParams({...params, ...props});
    }

    const initParams = () => {
        setParam({cliId: '', cliNm: ''});
    }

    const getCliList = async (param, type) => {
        if(cable === "Y") param.cable = "Y";
        await extSubmission(
            "/cpm/com/commCli/subList.do",
            param,
            (e, data) => {
                setOptions(formatSelect(data.listMain, 'cliNm', 'cliId'))
                if (type === 'Enter'){
                    if (data.listMain.length === 1) {
                        onChangeSelect(formatSelect(data.listMain, 'cliNm', 'cliId')[0]);
                    } else {
                        handleModal();
                    }
                }
            },
            'N'
        );
    }

    const onChangeSelect = (select) => {
        setParam({cliNm: select.label, cliId: select.value});
    }

    const onChangeSelectInput = (value) => {
        if (value.length === 1) {
            initParams();
        } else if (value.length >= 2) {
            getCliList({cliId: value, agncyId: params.agncyId});
        } else {
            setOptions([]);
        }
    }

    const handleModal = () => {
        setModalIsOpen(!modalIsOpen);
    }

    const onChangeAgncyId = (e) => {
        setParam({cliNm: '', cliId: e.target.value});
    }

    const onChangeParams = (value) => {
        setParam({cliId: value.cliId, cliNm: value.cliNm});
    }

    const onKeyPressAgncyId = async (e) => {
        if (e.key === 'Enter') {
            await getCliList({cliId: params.cliId, agncyId: params.agncyId}, 'Enter');
        }
    }

    const onClick_Btn = () => {
        if(!disabled){   
            initParams(); 
            handleModal();
        }
    }

    useDidMountEffect(() => {
        !disabled && initParams()
    }, [params?.agncyNm, params?.agncyId])

    useEffect(() => {
        if(sessionStorage.getItem("cliNm") && !params.cliNm){
            const cliNm = sessionStorage.getItem("cliNm")
            const cliId = sessionStorage.getItem("cliId")
            const agncyId = '0010000';
            const agncyNm = '직거래';
            setParams({agncyId, agncyNm, cliId, cliNm})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const selectProps = {
        options,
        select: {value: params.cliId, label: params.cliNm},
        onChangeSelect,
        onChangeInput: onChangeSelectInput,
        selectRef: focusCliRef,
        isDisabled: disabled,
        name: "광고주",
        essential
    }

    const modalProps = {
        cliStr: params.cliId,
        agncyId: params.agncyId,
        modalIsOpen,
        handleModal,
        onChangeParams,
        cable: cable || ""
    }

    return (
        <>
            <Form 
                className='d-flex align-items-center'
                autoComplete="off"
                style={{width: '280px',minWidth: '250px', maxWidth:'300px' }}
            >
                <Input
                    className={`${essential && 'essential'} form-control-sm me-1`}
                    style={{
                        width: '80px',
                        textAlign: 'center'
                    }}
                    name="광고주"
                    id="cliId"
                    value={params.cliId || ''}
                    onKeyPress={onKeyPressAgncyId}
                    onChange={onChangeAgncyId}
                    onFocus={(e) => e.target.select()}
                    disabled={disabled}
                    maxLength={8}
                    />
                    <CommSelect {...selectProps} />
                {!disabled && <Button size='sm'
                          color=''
                          className='btn-icon btn-sm  btn-soft-dark px-2 fs-6 rounded-1 bx bx-search'
                          style={{borderColor:"#a9a8a8",height:"28px", width:"28px"  }}
                          disabled={disabled}
                        onClick={onClick_Btn}>
                </Button>}
            </Form>
            <CommPFindCli {...modalProps}/>
        </>
    )
};

export default CpmCommCli;